var _rect, _path, _circle, _path2, _rect2, _rect3, _rect4, _rect5, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconEnterEmail = function SvgIconEnterEmail(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 100,
    viewBox: "0 0 132 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 35,
    width: 64,
    height: 50,
    rx: 8,
    fill: "#E0FBFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 48.9834L66 61.7547L98 48.9834V55.5248L67.246 68.7708C66.4435 69.0765 65.5565 69.0765 64.754 68.7708L34 55.5248V48.9834Z",
    fill: "#A5D6D3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 37,
    r: 9,
    fill: "#78A7F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.291 33.031C102.93 33.7096 102.898 34.7776 102.219 35.4163L95.8441 41.4163C95.2114 42.0118 94.2301 42.0296 93.5763 41.4575L90.5763 38.8325C89.8749 38.2188 89.8038 37.1527 90.4175 36.4513C91.0313 35.7499 92.0974 35.6788 92.7987 36.2925L94.6462 37.909L99.906 32.9587C100.585 32.3199 101.653 32.3523 102.291 33.031Z",
    fill: "#FBFBFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.333,
    y: 18.0244,
    width: 4.33333,
    height: 13,
    rx: 2.16667,
    fill: "#87CBC8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 22.3579,
    width: 4.33333,
    height: 13,
    rx: 2.16667,
    transform: "rotate(90 28 22.3579)",
    fill: "#87CBC8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 113.077,
    y: 82.8413,
    width: 3.25271,
    height: 9.75813,
    rx: 1.62635,
    transform: "rotate(60 113.077 82.8413)",
    fill: "#FFAFAF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 113.514,
    y: 90.1016,
    width: 3.25271,
    height: 9.75813,
    rx: 1.62635,
    transform: "rotate(150 113.514 90.1016)",
    fill: "#FFAFAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0938 17.0308C43.7545 16.3287 43.312 15.6955 42.7709 15.1338C42.6519 15.0077 42.527 14.881 42.401 14.7657C42.4934 14.5701 42.5721 14.3718 42.6363 14.1673C42.9041 13.3991 42.9856 12.6091 42.8815 11.8007L42.8621 11.7113C42.811 11.5706 42.721 11.4664 42.5878 11.3957C42.4581 11.3242 42.32 11.3088 42.174 11.3438C41.3973 11.5864 40.7106 11.9856 40.1177 12.5407C39.9846 12.6608 39.8582 12.7944 39.7418 12.9222C38.8168 12.5155 37.8557 12.3653 36.8549 12.4724L36.7748 12.4914C36.6355 12.5399 36.5292 12.6281 36.4566 12.7596C36.3876 12.8903 36.3704 13.0268 36.4036 13.1713C36.6494 13.9513 37.0554 14.641 37.6171 15.2375C37.7632 15.3934 37.915 15.5406 38.0781 15.6797C38.0124 15.8434 37.9562 16.007 37.8949 16.1735C37.638 16.9056 37.4999 17.6591 37.4851 18.4368C37.4689 18.5955 37.5121 18.7341 37.6139 18.8583C37.7157 18.9825 37.8454 19.0539 38.0043 19.0705C38.1288 19.0832 38.2433 19.0587 38.3514 18.9963C39.0512 18.6579 39.6777 18.2229 40.2393 17.6876C40.395 17.5421 40.5435 17.3981 40.6826 17.2449C40.8706 17.3264 41.0678 17.3984 41.2388 17.4535C41.9734 17.7157 42.7325 17.8585 43.5099 17.8777C43.604 17.88 43.692 17.8631 43.7747 17.8211C43.9273 17.7567 44.0347 17.6477 44.0983 17.4919C44.1583 17.3369 44.1574 17.1856 44.0938 17.0308Z",
    fill: "#F6C844"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconEnterEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/icon-enter-email.776903221cbac5396e01ff7bca4e4b70.blank.svg";